/**
 * Centralised reaction types — shared by ReactionBar, ForumPage, BriteLab,
 * Messages. Order matters (it's the order the picker renders them in).
 */
export const REACTION_TYPES = [
  { type: 'like',       emoji: '\uD83D\uDC4D', label: 'Like' },
  { type: 'love',       emoji: '\u2764\uFE0F', label: 'Love' },
  { type: 'funny',      emoji: '\uD83D\uDE02', label: 'Funny' },
  { type: 'celebrate',  emoji: '\uD83C\uDF89', label: 'Celebrate' },
  { type: 'insightful', emoji: '\uD83D\uDCA1', label: 'Insightful' },
];

export const REACTION_BY_TYPE = Object.fromEntries(REACTION_TYPES.map(r => [r.type, r]));

export const VALID_REACTION_TYPES = REACTION_TYPES.map(r => r.type);
